module.exports = __webpack_public_path__ + "static/media/stripe-create-account_10.85c9fa89.png";